var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.069,
    height: 52.875,
    viewBox: "0 0 53.069 52.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_294",
    x: 5.472,
    y: 5.473,
    width: 22.067,
    height: 22.064,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_295",
    x: 18.812,
    y: 18.62,
    width: 22.064,
    height: 22.064,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_296",
    x: 18.812,
    y: 26.747,
    width: 22.064,
    height: 22.067,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_297",
    x: 22.876,
    y: 22.682,
    width: 22.064,
    height: 22.064,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_298",
    x: 31.005,
    y: 22.682,
    width: 22.064,
    height: 22.064,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_299",
    x: 26.937,
    y: 18.62,
    width: 22.065,
    height: 22.064,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_300",
    x: 26.937,
    y: 30.81,
    width: 22.065,
    height: 22.065,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_362",
    x: 0,
    y: 0,
    width: 33.011,
    height: 33.012,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_301",
    x: 24.127,
    y: 5.473,
    width: 22.064,
    height: 22.064,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_363",
    x: 18.653,
    y: 0,
    width: 33.014,
    height: 33.012,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_302",
    x: 5.499,
    y: 24.099,
    width: 22.064,
    height: 22.064,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_364",
    x: 0.025,
    y: 18.624,
    width: 33.014,
    height: 33.013,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4fb2d9",
    floodOpacity: 0.478
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_187",
    "data-name": "Groupe 187",
    transform: "translate(9 -0.393)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Rectangle_294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294-2",
    "data-name": "Rectangle 294",
    width: 4.067,
    height: 4.064,
    transform: "translate(14.47 6.47)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Rectangle_295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295-2",
    "data-name": "Rectangle 295",
    width: 4.064,
    height: 4.064,
    transform: "translate(27.81 19.62)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Rectangle_296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296-2",
    "data-name": "Rectangle 296",
    width: 4.064,
    height: 4.067,
    transform: "translate(27.81 27.75)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Rectangle_297)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297-2",
    "data-name": "Rectangle 297",
    width: 4.064,
    height: 4.064,
    transform: "translate(31.88 23.68)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Rectangle_298)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298-2",
    "data-name": "Rectangle 298",
    width: 4.064,
    height: 4.064,
    transform: "translate(40 23.68)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Rectangle_299)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299-2",
    "data-name": "Rectangle 299",
    width: 4.065,
    height: 4.064,
    transform: "translate(35.94 19.62)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Rectangle_300)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300-2",
    "data-name": "Rectangle 300",
    width: 4.065,
    height: 4.065,
    transform: "translate(35.94 31.81)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Trac\\xE9_362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_362-2",
    "data-name": "Trac\\xE9 362",
    d: "M13.838,16.405H1.174A1.173,1.173,0,0,1,0,15.232V2.567A1.174,1.174,0,0,1,1.174,1.393H13.838a1.174,1.174,0,0,1,1.174,1.174V15.232A1.174,1.174,0,0,1,13.838,16.405ZM2.347,14.058H12.664V3.74H2.347Z",
    transform: "translate(9 -0.39)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Rectangle_301)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301-2",
    "data-name": "Rectangle 301",
    width: 4.064,
    height: 4.064,
    transform: "translate(33.13 6.47)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Trac\\xE9_363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_363-2",
    "data-name": "Trac\\xE9 363",
    d: "M286.171,16.405H273.5a1.174,1.174,0,0,1-1.174-1.174V2.567A1.174,1.174,0,0,1,273.5,1.393h12.666a1.173,1.173,0,0,1,1.174,1.174V15.232A1.174,1.174,0,0,1,286.171,16.405Zm-11.493-2.347H285V3.74H274.678Z",
    transform: "translate(-244.68 -0.39)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Rectangle_302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302-2",
    "data-name": "Rectangle 302",
    width: 4.064,
    height: 4.064,
    transform: "translate(14.5 25.1)",
    fill: "#4fb2d9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, 0.39)",
    filter: "url(#Trac\\xE9_364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_364-2",
    "data-name": "Trac\\xE9 364",
    d: "M14.2,288.319H1.536a1.174,1.174,0,0,1-1.174-1.174V274.48a1.174,1.174,0,0,1,1.174-1.174H14.2a1.174,1.174,0,0,1,1.174,1.174v12.665A1.175,1.175,0,0,1,14.2,288.319ZM2.709,285.971H13.028V275.654H2.709Z",
    transform: "translate(8.66 -253.68)",
    fill: "#4fb2d9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.0ae99bb313f4651793bc43bfa48b3901.svg";
export { ForwardRef as ReactComponent };